export const ALERT_READ_CHANGED_EVENT = "trading-alert-read-changed";

export function notifyAlertReadChanged(): void {
  window.dispatchEvent(new Event(ALERT_READ_CHANGED_EVENT));
}
